'use strict';

var chainedSelectorFactory = require('./helpers/chainedSelectorFactory');

module.exports = chainedSelectorFactory('AdjacentSelector', '+');